import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ClinicLicenseGuard } from './core/guards/clinic-license.guard';
import { LayoutComponent } from './layouts/layout.component';
import { AppRedirectComponent } from './pages/app-redirect/app-redirect.component';
import { NoClinicAccessComponent } from './pages/no-clinic-access/no-clinic-access.component';

const routes: Routes = [
  { path: 'app-redirect', component: AppRedirectComponent },
  {
    path: 'no-clinic-access',
    component: NoClinicAccessComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
    canActivate: [AuthGuard, ClinicLicenseGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
